import { useFormik } from "formik";
import { articleFormSchema } from "libs/validation/schemas";
import mediaUploader from "api/mediaUploader.api";
import useAuth from "hooks/useAuth";
import { CACHE_SIZE_UNLIMITED } from "firebase/firestore";
import { runFireworks } from "components/confetti";

const FIELDS = {
  TITLE: "title",
  DESCRIPTION: "description",
  CONTENT: "content",
  CACHE_SIZE_UNLIMITED,
  CATEGORIES: "categories",
  PUBLISHED: "published",
  PREDICTOR: "predictor",
  LEVEL: "level",
  DEADLINE: "deadline",
  END_OF_VOTING: "endOfVoting",
  IMAGE: "image",
};

const usePredictionForm = (props) => {
  const { prediction, create, update, id } = props;
  const { currentUser } = useAuth();
  const predictionForm = useFormik({
    initialValues: {
      [FIELDS.TITLE]: prediction.title || "",
      [FIELDS.DESCRIPTION]: prediction.description || "",
      [FIELDS.CONTENT]: prediction.content || "",
      [FIELDS.CATEGORIES]: prediction.categories || [],
      [FIELDS.PUBLISHED]: prediction.published || false,
      [FIELDS.PREDICTOR]: prediction.predictor || "",
      [FIELDS.LEVEL]: prediction.level || 1,
      [FIELDS.DEADLINE]: prediction.deadline || "",
      [FIELDS.END_OF_VOTING]: prediction.endOfVoting || "",
      [FIELDS.IMAGE]: prediction.image || "",
    },
    enableReinitialize: true,
    validationSchema: articleFormSchema,
    onSubmit: async (values) => {
      let contentUrl = "";
      let imageUrl = "";

      if (typeof values[FIELDS.IMAGE] !== "string") {
        imageUrl = await mediaUploader(
          values[FIELDS.IMAGE],
          `predictions/${id}/image`,
        );
      } else {
        imageUrl = values[FIELDS.IMAGE];
      }

      if (values[FIELDS.CONTENT]) {
        const blob = new Blob([values[FIELDS.CONTENT]], { type: "text/plain" });
        const file = new File([blob], "content.txt", { type: "text/plain" });
        contentUrl = await mediaUploader(file, `predictions/${id}/content`);
      }

      create({
        ...values,
        image: imageUrl,
        createdAt: Date.now(),
        content: contentUrl,
        author: { id: currentUser?.id, displayName: currentUser.displayName },
        type: "pending",
      });
      update(id, {
        ...values,
        image: imageUrl,
        content: contentUrl,
        updatedAt: Date.now(),
      });
      runFireworks();
    },
  });

  const { values, setFieldValue, handleSubmit, resetForm } = predictionForm;

  return {
    predictionForm,
    FIELDS,
    values,
    setFieldValue,
    handleSubmit,
    resetForm,
    errors: predictionForm.errors,
  };
};

export default usePredictionForm;
